import SpeakersListLayout from '../../enums/speakers_list_layout'

export default{
  namespaced: true,
  state: {
    updateUiImmediately: true,
    showSpeakersOnScreen: true,
    speakersListLayout: SpeakersListLayout.CAROUSEL,
    showSpeakersOnScreenTwo: true,
    speakersListTwoLayout: SpeakersListLayout.CAROUSEL,
    ontimeUrl: 'http://localhost:4001'
  },
  getters: {
    showSpeakersOnScreen: (state) => state.showSpeakersOnScreen,
    speakersListLayout: (state) => state.speakersListLayout,
    showSpeakersOnScreenTwo: (state) => state.showSpeakersOnScreenTwo,
    speakersListTwoLayout: (state) => state.speakersListTwoLayout,
    ontimeUrl: (state) => state.ontimeUrl
  },
  mutations: {
    SET_SHOW_SPEAKERS_ON_SCREEN (state, show) {
      state.showSpeakersOnScreen = show
    },
    SET_SPEAKERS_LIST_LAYOUT (state, layout) {
      console.log('setting layout')
      state.speakersListLayout = layout
    },
    SET_SHOW_SPEAKERS_ON_SCREEN_TWO (state, show) {
      state.showSpeakersOnScreenTwo = show
    },
    SET_SPEAKERS_LIST_TWO_LAYOUT (state, layout) {
      state.speakersListTwoLayout = layout
    },
    SET_ONTIME_URL (state, url) {
      state.ontimeUrl = url
    }
  },
  actions: {
    initPusher ({dispatch, commit}) {
      this.$channels.screen.bind('show-speakers', (payload) => {
        commit('SET_SHOW_SPEAKERS_ON_SCREEN', true)
      })
      this.$channels.screen.bind('hide-speakers', (payload) => {
        commit('SET_SHOW_SPEAKERS_ON_SCREEN', false)
      })
    },
    async saveShowSpeakers ({commit}, extra = {}) {
      await this.$api.showSpeakers()
    },
    async saveHideSpeakers ({commit}, extra = {}) {
      await this.$api.hideSpeakers()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js